import 'react-perfect-scrollbar/dist/css/styles.css';

import React from 'react';
import { makeStyles, Container } from '@material-ui/core';

import LeftDrawer from 'src/features/me/leftDrawer';
import Header from 'src/features/me/header';

const drawerWidth = 270;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  toolbar: theme.mixins.toolbar,
  content: ({ drawerWidth }) => ({
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    flexGrow: 1,
    // padding: theme.spacing(3,0),
    flexDirection: 'column',
  }),
}));

export default function DesktopLayout({ children }) {
  const classes = useStyles({ drawerWidth });

  return (
    <div className={classes.root}>
      <Header drawerWidth={drawerWidth} />
      <LeftDrawer drawerWidth={drawerWidth} />
      <main className={classes.content}>
        <Container>
          {children}
          {/* <Footer /> */}
        </Container>
      </main>
    </div>
  );
}
